"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from "react";
import { TraitsData } from "./submission/types/TraitsData";
import { Section, TraitField } from "./traits";
import { getFormSections } from "./traits/schema";
import { useAuth } from "@/components/auth/Auth";
interface MemesArtSubmissionTraitsProps {
  readonly traits: TraitsData;
  readonly setTraits: (traits: Partial<TraitsData>) => void;
  readonly validationErrors?: Record<keyof TraitsData, string | null>;
  readonly onFieldBlur?: (field: keyof TraitsData) => void;
}

/**
 * MemesArtSubmissionTraits - Component for managing all artwork trait fields
 *
 * Simplified implementation with direct updates to the central state
 */
const MemesArtSubmissionTraits: React.FC<MemesArtSubmissionTraitsProps> = t0 => {
  const $ = _c(28);
  const {
    traits,
    setTraits,
    validationErrors: t1,
    onFieldBlur
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const validationErrors = t2;
  const {
    connectedProfile
  } = useAuth();
  const userProfile = connectedProfile?.handle;
  let t3;
  if ($[2] !== setTraits) {
    t3 = (field, value) => {
      setTraits({
        [field]: value
      });
    };
    $[2] = setTraits;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const updateText = t3;
  let t4;
  if ($[4] !== setTraits) {
    t4 = (field_0, value_0) => {
      setTraits({
        [field_0]: value_0
      });
    };
    $[4] = setTraits;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const updateBoolean = t4;
  let t5;
  if ($[6] !== setTraits) {
    t5 = (field_1, value_1) => {
      setTraits({
        [field_1]: value_1
      });
    };
    $[6] = setTraits;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const updateNumber = t5;
  let t6;
  if ($[8] !== userProfile) {
    t6 = getFormSections(userProfile);
    $[8] = userProfile;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const formSections = t6;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <h2 className="tw-text-lg sm:tw-text-xl tw-font-semibold tw-text-iron-100 tw-mb-4">Artwork Traits</h2>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== formSections || $[12] !== onFieldBlur || $[13] !== traits || $[14] !== updateBoolean || $[15] !== updateNumber || $[16] !== updateText || $[17] !== validationErrors) {
    let t9;
    if ($[19] !== onFieldBlur || $[20] !== traits || $[21] !== updateBoolean || $[22] !== updateNumber || $[23] !== updateText || $[24] !== validationErrors) {
      t9 = (section, sectionIndex) => <Section key={`section-${sectionIndex}`} title={section.title}><div className="tw-flex tw-flex-col tw-gap-6">{section.fields.map((field_2, fieldIndex) => <TraitField key={`field-${field_2.field}-${fieldIndex}`} definition={field_2} traits={traits} updateText={updateText} updateNumber={updateNumber} updateBoolean={updateBoolean} error={validationErrors[field_2.field]} onBlur={onFieldBlur ? () => onFieldBlur(field_2.field) : undefined} />)}</div></Section>;
      $[19] = onFieldBlur;
      $[20] = traits;
      $[21] = updateBoolean;
      $[22] = updateNumber;
      $[23] = updateText;
      $[24] = validationErrors;
      $[25] = t9;
    } else {
      t9 = $[25];
    }
    t8 = formSections.map(t9);
    $[11] = formSections;
    $[12] = onFieldBlur;
    $[13] = traits;
    $[14] = updateBoolean;
    $[15] = updateNumber;
    $[16] = updateText;
    $[17] = validationErrors;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[26] !== t8) {
    t9 = <div className="tw-flex tw-flex-col tw-gap-y-1">{t7}<div className="tw-flex tw-flex-col tw-gap-y-8">{t8}</div></div>;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
};

// Use React.memo to prevent unnecessary rerenders
export default React.memo(MemesArtSubmissionTraits);